import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const ListadoGravedad = async (usuarioId) => {
    try {
        const resultado = await instance.Backend.post("/Hallazgo/ListadoGravedad", {
            idUsuario: usuarioId
        }, customConfig);

        return resultado

    } catch (error) {

        console.log(error);

    }

}
export { ListadoGravedad };